import { Link } from 'react-router-dom';
import { Head } from 'vite-react-ssg';
import FooterSection from '../../components/FooterSection';
import { WA_NUMBER } from '../../constant/detail';

const relatedServices = [
  { label: 'Jual Chemical Pool Bali', to: '/jual-chemical-pool-bali' },
  { label: 'Pasang Filter Kolam Renang Bali', to: '/pasang-filter-kolam-renang-bali' },
  { label: 'Jasa Testkit Air Kolam Bali', to: '/jasa-testkit-air-kolam-bali' },
  { label: 'Jual Equipment Pool Bali', to: '/equipment-pool-bali' },
  { label: 'Konsultasi Kolam Renang Bali', to: '/konsultasi-kolam-renang-bali' },
];

const WA_MESSAGE = encodeURIComponent(
  'Halo, saya ingin konsultasi jasa maintenance kolam renang di Bali'
);

const faqData = [
  {
    q: 'Berapa biaya jasa bersih kolam renang di Bali?',
    a: 'Biaya jasa bersih kolam renang di Bali bervariasi tergantung ukuran kolam, kondisi air, dan frekuensi kunjungan. Kami menawarkan paket mingguan dan bulanan dengan harga transparan — tidak ada biaya tersembunyi. Hubungi kami via WhatsApp untuk estimasi harga sesuai kolam Anda.',
  },
  {
    q: 'Seberapa sering kolam renang di Bali perlu dirawat?',
    a: 'Di Bali dengan iklim tropis yang lembap, kami merekomendasikan perawatan minimal seminggu sekali. Kolam di bawah pohon rindang atau kolam villa dengan tamu aktif sebaiknya dirawat dua kali seminggu untuk menjaga kejernihan air dan keseimbangan kimia secara optimal.',
  },
  {
    q: 'Apakah bisa menangani air kolam yang sudah hijau atau keruh?',
    a: 'Ya. Kami menangani berbagai kondisi darurat kolam termasuk air hijau akibat alga, air keruh, dan waterline staining. Proses meliputi shock treatment, pembersihan mekanis menyeluruh, penyesuaian kimia, dan pembersihan filter. Kolam biasanya kembali jernih dalam 1–3 hari.',
  },
  {
    q: 'Apakah layanan Anda mencakup seluruh Bali?',
    a: 'Kami melayani seluruh wilayah Bali dengan fokus utama di Gianyar, Ubud, Tegallalang, Payangan, Tabanan, dan sekitarnya. Untuk area di luar Gianyar, silakan hubungi kami untuk konfirmasi ketersediaan jadwal.',
  },
  {
    q: 'Apakah ada garansi untuk setiap pekerjaan?',
    a: 'Ya. Setiap pekerjaan maintenance kami disertai garansi kepuasan. Jika kolam belum sesuai standar setelah kunjungan, kami akan kembali tanpa biaya tambahan hingga hasilnya memuaskan.',
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Jasa Maintenance Kolam Renang Bali',
  description:
    'Jasa maintenance kolam renang Bali profesional: pembersihan rutin, pengecekan pH & klorin, servis filter, penanganan air hijau. Melayani villa, hotel & resor se-Bali.',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Pool Shop Surya Jaya Teknik',
    telephone: '+628123618911',
    url: 'https://poolshopsuryajayateknik.com',
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: 'Jalan Raya Andong, Petulu',
        addressLocality: 'Gianyar',
        addressRegion: 'Bali',
        addressCountry: 'ID',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Jl. Raya Kengetan, Lodtunduh',
        addressLocality: 'Gianyar',
        addressRegion: 'Bali',
        addressCountry: 'ID',
      },
    ],
  },
  areaServed: { '@type': 'AdministrativeArea', name: 'Bali, Indonesia' },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '08:00',
    closes: '17:00',
  },
  url: 'https://poolshopsuryajayateknik.com/jasa-maintenance-kolam-renang-bali',
};

const MaintenanceKolamRenang = () => {
  return (
    <>
      <Head>
        <title>Jasa Maintenance Kolam Renang Bali | Villa &amp; Hotel | SJT</title>
        <meta
          name="description"
          content="Jasa maintenance kolam renang Bali profesional. Cleaning rutin, cek pH & klorin, servis filter. Melayani villa & hotel se-Bali. Konsultasi gratis sekarang!"
        />
        <link rel="canonical" href="https://poolshopsuryajayateknik.com/jasa-maintenance-kolam-renang-bali" />
        <meta property="og:title" content="Jasa Maintenance Kolam Renang Bali | Villa & Hotel | SJT" />
        <meta property="og:description" content="Jasa maintenance kolam renang Bali profesional. Cleaning rutin, cek pH & klorin, servis filter. Melayani villa & hotel se-Bali." />
        <meta property="og:image" content="https://poolshopsuryajayateknik.com/img/blog/img-2.jpg" />
        <meta property="og:url" content="https://poolshopsuryajayateknik.com/jasa-maintenance-kolam-renang-bali" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Jasa Maintenance Kolam Renang Bali | Villa & Hotel | SJT" />
        <meta name="twitter:description" content="Jasa maintenance kolam renang Bali profesional. Cleaning rutin, cek pH & klorin, servis filter. Melayani villa & hotel se-Bali." />
        <script type="application/ld+json">
          {JSON.stringify(serviceSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Head>

      <main className="mt-16 bg-white text-gray-800">
        {/* Hero */}
        <section className="bg-tertiary text-white py-16 px-6 text-center">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold leading-tight mb-4">
              Jasa Maintenance Kolam Renang di Bali Profesional
            </h1>
            <p className="text-lg md:text-xl text-primary/80 mb-8">
              Kolam renang kotor, air hijau, atau pompa bermasalah? Kami hadir
              dengan solusi jasa maintenance kolam renang di Bali yang
              terlengkap. Teknisi kami yang berpengalaman siap menjaga kolam
              renang Anda tetap bersih, jernih, dan aman digunakan sepanjang
              tahun. Layanan kami mencakup pembersihan manual, pemeriksaan
              sistem filtrasi, pengukuran pH, dan penanganan jasa perawatan
              kolam renang di Bali dari alga hingga kebocoran. Kepuasan
              pelanggan adalah prioritas utama kami di setiap pekerjaan.
            </p>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary hover:opacity-90 text-tertiary font-semibold py-3 px-8 rounded-full text-lg transition"
            >
              Consultation via WhatsApp
            </a>
          </div>
        </section>

        {/* Why */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-4">
            Why Does Your Pool Need Regular Maintenance?
          </h2>
          <p className="mb-4 leading-relaxed">
            Many pool owners in Bali neglect routine maintenance until a major
            problem appears, such as green water caused by uncontrolled algae
            growth. The hot and humid tropical climate in Bali accelerates the
            growth of bacteria and algae in pool water. Without regular
            maintenance, pH and chlorine levels can change drastically within
            days, which is dangerous for users. Mechanical components such as
            pumps, filters, and skimmers also need periodic inspection to stay
            in optimal condition. By using a professional pool maintenance
            service, you can save on costly repairs caused by issues left
            untreated.
          </p>
          <p className="leading-relaxed">
            Suryajaya Teknik offers a complete pool maintenance solution in Bali
            with a structured and scheduled approach. We make regular visits
            based on your needs, whether weekly or monthly, and provide a pool
            condition report after every visit. Our team uses digital meters to
            ensure chlorine and pH levels are always within the safe range set
            by WHO standards. Every technician is trained and experienced in
            handling all types of pools, from private pools and villas to hotels
            and public facilities. We are committed to delivering the best
            service at transparent and competitive prices across Bali.
          </p>
        </section>

        {/* Services */}
        <section className="bg-primary/10 py-14 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold text-tertiary mb-4">
              Our Pool Maintenance Services
            </h2>
            <p className="mb-6 leading-relaxed">
              We provide comprehensive pool maintenance services that can be
              tailored to your specific needs. Every service package is designed
              to keep your pool in top condition and safe to use at all times.
              Our technicians arrive on time with all the necessary equipment
              and chemicals. We also provide technical recommendations if any
              signs of damage are found in your pool system. With over 10 years
              of experience in this industry, we understand the unique needs of
              every type of pool in Bali.
            </p>
            <ul className="space-y-3">
              {[
                'Manual cleaning of pool walls, floor, and surfaces',
                'Measuring and balancing pool water pH levels',
                'Adding chlorine and pool chemicals as needed',
                'Inspection and servicing of circulation pumps',
                'Cleaning of sand, cartridge, or DE filters',
                'Treatment of green or cloudy pool water',
                'Pipe system inspection and leak detection',
                'Pool condition report after every visit',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="text-tertiary font-bold mt-0.5">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* Why Us */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-6">
            Why Choose Suryajaya Teknik?
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              {
                title: 'Experienced Technicians',
                desc: 'Our team has serviced hundreds of pools across Bali for over a decade.',
              },
              {
                title: 'Transparent Pricing',
                desc: 'No hidden fees. A price estimate is given before work begins.',
              },
              {
                title: 'Flexible Scheduling',
                desc: 'Available every day including weekends and public holidays.',
              },
              {
                title: 'Certified Chemicals',
                desc: 'We only use pool chemicals that meet international safety standards.',
              },
              {
                title: 'Work Guarantee',
                desc: 'Every job comes with a satisfaction guarantee. Not happy? We come back at no extra cost.',
              },
              {
                title: 'Digital Reports',
                desc: 'Customers receive a pool condition report via WhatsApp after every visit.',
              },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white border border-primary rounded-xl p-5 shadow-sm"
              >
                <h3 className="font-semibold text-tertiary mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Jasa Bersih Kolam Renang */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-4">
            Jasa Bersih Kolam Renang di Bali — Bukan Sekadar Sikat Dinding
          </h2>
          <p className="mb-4 leading-relaxed">
            Banyak pemilik villa dan properti di Bali mencari <strong>jasa bersih kolam renang di Bali</strong> yang tidak hanya membersihkan permukaan, tetapi juga menjaga kualitas air secara menyeluruh. Surya Jaya Teknik menyediakan layanan pembersihan kolam renang lengkap — mulai dari vakum lantai, sikat dinding dan waterline, pembersihan skimmer dan filter, hingga pengukuran dan penyeimbangan kimia air setiap kunjungan.
          </p>
          <p className="leading-relaxed">
            Pembersihan kolam yang benar bukan hanya soal air yang terlihat jernih. Air kolam yang tidak seimbang pH dan klorinnya bisa tampak bening tapi tetap menjadi tempat berkembangnya bakteri. Itulah mengapa setiap kunjungan jasa bersih kolam renang kami selalu diakhiri dengan laporan pengukuran kimia air — bukan hanya laporan visual. Kami menggunakan alat uji digital dan reagen DPD untuk memastikan free chlorine, pH, alkalinitas, dan calcium hardness berada dalam rentang yang aman dan nyaman untuk pengguna kolam.
          </p>
        </section>

        {/* FAQ */}
        <section className="bg-primary/10 py-14 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold text-tertiary mb-6">
              Pertanyaan Umum Seputar Jasa Maintenance Kolam Renang di Bali
            </h2>
            <div className="space-y-5">
              {faqData.map((item, i) => (
                <div key={i} className="bg-white border border-gray-200 rounded-xl p-5">
                  <h3 className="font-semibold text-tertiary mb-2">{item.q}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-tertiary text-white py-16 px-6 text-center">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold mb-4">
              Need Pool Maintenance Service in Bali?
            </h2>
            <p className="text-primary/80 mb-8">
              Contact us now for a consultation and the best price offer. Our
              team is ready to help you keep your pool clean, clear, and safe to
              use at all times. Do not wait until the problem gets bigger -
              reach out to Suryajaya Teknik and feel the difference.
            </p>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary hover:opacity-90 text-tertiary font-semibold py-3 px-10 rounded-full text-lg transition"
            >
              Contact Us via WhatsApp
            </a>
          </div>
        </section>

        {/* Related Services */}
        <section className="max-w-4xl mx-auto py-10 px-6">
          <h2 className="text-lg font-bold text-tertiary mb-4">Layanan Lainnya</h2>
          <div className="flex flex-wrap gap-3">
            {relatedServices.map(({ label, to }) => (
              <Link
                key={to}
                to={to}
                className="text-sm font-medium text-primary border border-primary/40 px-4 py-2 rounded-full hover:bg-primary/10 transition"
              >
                {label}
              </Link>
            ))}
          </div>
        </section>

        <FooterSection />
      </main>
    </>
  );
};

export default MaintenanceKolamRenang;
